import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { filter, map, Observable } from 'rxjs';
import { MealPlanPreferenceName, PreferenceValue } from '../choose-meal-plan';

export interface MealPlanModifyPreferencesState {
	preferences: MealPlanPreferences | null;
}

export type MealPlanPreferences = {
	[key in MealPlanPreferenceName]: PreferenceValue;
};

export const defaultState: MealPlanModifyPreferencesState = {
	preferences: null,
};

@Injectable()
export class MealPlanModifyPreferencesStore extends ComponentStore<MealPlanModifyPreferencesState> {
	/** Selectors */
	public readonly selectPreferences$: Observable<MealPlanPreferences> = this.select(
		({ preferences }) => preferences
	).pipe(
		filter((preferences) => !!preferences),
		map((preferences) => preferences as MealPlanPreferences)
	);

	/** Updaters */
	public readonly updatePreferences = this.updater((state, preferences: MealPlanPreferences) => ({
		...state,
		preferences,
	}));

	constructor() {
		super(defaultState);
	}
}
